import Navbar from "./Navbar";
import Footer from "./Footer";
import CampusAmbassadorDetails from "./Campus_Ambassador/CampusAmbassador_Details";
import TeamShowcase from "./Campus_Ambassador/Our_Team";
import CampusAmbassadorForm from "./Campus_Ambassador/CampusAmbassadorForm";
import './Css/campus_ambassador.css';

function CampusAmbassador() {
  return (
    <div>
      <Navbar />
      <CampusAmbassadorDetails />
      <TeamShowcase />
      <CampusAmbassadorForm />
      <Footer />
    </div>
  );
}

export default CampusAmbassador;